import pdfImage from "../../components/PDF/pdfImage";
import { generatePdf } from "../../utilities/PDFMakeUtil";

export const pdfRPT234 = (dataReport, setLoading, setDialogPDF) => {
    setLoading(true);

    const filterRowData = () => {
        let arr = [];
        arr.push([
            { text: "รายการ", style: "tableHeader", alignment: "center" },
            { text: "จำนวนเงิน (บาท)", style: "tableHeader", alignment: "center" },
        ]);
        arr.push([" " + dataReport.item1Desc, { text: dataReport.item1Value, alignment: "center" }]);
        arr.push([" " + dataReport.item2Desc, { text: dataReport.item2Value, alignment: "center" }]);
        arr.push([" " + dataReport.item3Desc, { text: dataReport.item3Value, alignment: "center" }]);
        arr.push([" " + dataReport.item4Desc, { text: dataReport.item4Value, alignment: "center" }]);
        arr.push([" " + dataReport.item5Desc, { text: dataReport.item5Value, alignment: "center" }]);
        arr.push([" " + dataReport.item6Desc, { text: dataReport.item6Value, alignment: "center" }]);
        arr.push([" " + dataReport.item7Desc, { text: dataReport.item7Value, alignment: "center" }]);
        arr.push([" " + dataReport.item8Desc, { text: dataReport.item8Value, alignment: "center" }]);
        if (dataReport.item9Desc != null) arr.push([" " + dataReport.item9Desc, { text: dataReport.item9Value, alignment: "center" }]);
        arr.push(["ยอดรวมขอเบิก - จ่าย งวดนี้", { text: "" + dataReport.itemTotalValue, alignment: "center" }]);

        return arr;
    };

    var dd = {
        content: [
            {
                columns: [
                    { width: 200, text: "" },
                    {
                        width: 100,
                        height: 90,
                        image: pdfImage.logo_2,
                    },
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        style: "fontStyle",
                        table: {
                            body: [
                                [
                                    {
                                        style: { alignment: "right" },
                                        widths: [50, 50],
                                        table: {
                                            body: [
                                                [
                                                    { text: "เลขที่สัญญา", style: "fontStyle" },
                                                    { text: "   " + dataReport.contractNo + "   ", style: "fontStyle" },
                                                ],
                                            ],
                                        },
                                        layout: "noBorders",
                                    },
                                ],
                                [
                                    {
                                        // style: 'tableExample',
                                        widths: [50, 50],
                                        table: {
                                            body: [
                                                [
                                                    { style: "fontStyle", text: "งวดที่" },
                                                    { style: "fontStyle", text: "  " + dataReport.withdrawSeq + "  ", style: "signature" },
                                                    // { style: "fontStyle", text: "(ครั้งสุดท้าย)" }, มาจาก swagger
                                                ],
                                            ],
                                        },
                                        layout: "noBorders",
                                    },
                                ],
                            ],
                        },
                    },
                ],
            },
            { text: "", margin: [0, 10, 0, 8] },
            {
                style: "center",
                columns: [
                    { width: 150, text: "" },
                    { width: 200, style: "fontStyle_bold", text: "ใบสรุปการขอเบิกจ่ายเงินค่างานก่อสร้าง งวดที่" },
                    { width: 10, style: "fontStyle", text: dataReport.withdrawSeq + "  ", style: "signature" },
                ],
            },
            {
                columns: [
                    { width: 20, text: "" },
                    { width: 30, style: "fontStyle", text: "เลขที่" },
                    { width: 200, style: "signature", text: dataReport.p2LetterNo == null ? "" : dataReport.p2LetterNo },
                    { width: 70, text: "" },
                    { width: 30, style: "fontStyle", text: "วันที่" },
                    { width: "*", style: "signature", text: dataReport.p2LetterDate },
                    { text: "" },
                ],
            },
            {
                columns: [
                    { width: 20, text: "" },
                    { width: 30, style: "fontStyle", text: "เรียน" },
                    { width: "*", style: "signature", text: dataReport.p2LetterTo == null ? "" : dataReport.p2LetterTo },
                ],
            },
            {
                columns: [
                    { margin: [50, 0, 0, 0], width: 200, style: "fontStyle", text: "ผู้ควบคุมงานเลขที่สัญญา " },
                    { margin: [0, 0, 0, 0], width: 100, style: "signature", text: "               " + dataReport.contractNo + "               " },
                    { margin: [0, 0, 0, 0], width: "*", style: "fontStyle", text: " ได้ตรวจสอบใบแจ้งหนี้" },
                ],
            },
            { margin: [20, 0, 0, 0], style: "fontStyle", text: "ในการเบิกจ่ายเงินค่างานก่อสร้างของผู้รับจ้างแล้ว ขอรับรองว่าถูกต้องสอดคล้องกับรายละเอียดงานก่อสร้างตามแบบฟอร์ม P-1" },
            {
                columns: [
                    { width: 20, text: "" },
                    { width: 30, style: "fontStyle", text: "ของ" },
                    { width: 160, style: "signature", text: " " + dataReport.contractorInfo + " " },
                    { width: 50, style: "fontStyle", text: "รวมจำนวน" },
                    { width: "*", style: "signature", text: " " + dataReport.totalRoute + " " },
                    { width: 150, style: "fontStyle", text: "เส้นทาง ตามใบแจ้งหนี้ผู้รับจ้างเลขที่" },
                    { width: "*", style: "signature", text: dataReport.invoiceNo == null ? "" : dataReport.invoiceNo },
                ],
            },
            {
                columns: [
                    { width: 20, text: "" },
                    { width: 30, style: "fontStyle", text: "ลงวันที่ " },
                    { width: "*", style: "signature", text: dataReport.invoiceDate },
                    { width: 40, style: "fontStyle", text: "ดังนี้" },
                    { width: "*", text: "" },
                ],
            },
            { margin: [20, 0, 0, 0], style: "fontStyle", text: "สรุปค่างานที่ขอเบิก - จ่ายในงวดนี้" },
            { text: "", margin: [0, 10, 0, 8] },
            {
                table: {
                    widths: ["*", 100],
                    headerRows: 2,
                    style: "fontStyle",
                    body: filterRowData(),
                },
            },
            { text: "", margin: [0, 10, 0, 8] },
            { margin: [20, 0, 0, 0], style: "fontStyle", text: "จึงเรียนมาเพื่อโปรดพิจารณา อนุมัติการขอเบิกจ่ายเงินค่างาน และสั่งการ ฝกง. ดำเนินการเบิกจ่ายเงินค่างานให้ผู้รับจ้าง ต่อไป" },
            { text: "", margin: [0, 10, 0, 8] },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "ลงนาม........................................................",
                        style: "fontStyle",
                    },
                    { width: 80, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "(" + dataReport.supervisorName + ")",
                        style: "signature",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "(" + dataReport.supervisorTitle + ")",
                        style: "signature",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: "*", text: "" },
                    {
                        width: "auto",
                        text: "ผู้คุมงาน",
                        style: "fontStyle",
                    },
                    { width: 150, text: "" },
                ],
            },
            { text: "", margin: [0, 10, 0, 8] },
            {
                columns: [
                    {
                        width: "auto",
                        text: "อนุมัติ",
                        style: "fontStyle",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    {
                        width: "auto",
                        text: "เรียน ผอ.ฝกง",
                        style: "fontStyle",
                    },
                    { width: 80, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: 20, text: "" },
                    {
                        width: "auto",
                        text: "เพื่อโปรดดำเนินการเบิก จ่ายเงินให้ผู้รับจ้าง ต่อไป",
                        style: "fontStyle",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: 20, text: "" },
                    {
                        width: "auto",
                        text: "ลงนาม ................................................",
                        style: "fontStyle",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    { width: 30, text: "" },
                    {
                        width: "auto",
                        text: "(................................................)",
                        style: "fontStyle",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
            {
                columns: [
                    {
                        width: "auto",
                        text: "ผจ.สส../ขวก.(ก...)/รวก(กต)/ขวก(บ)/รวก(บ)",
                        style: "fontStyle",
                    },
                    { width: 90, text: "" },
                ],
                style: "fontStyle",
            },
        ],
        styles: {
            header: {
                alignment: "right",
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            fontStyle: {
                fontSize: 14,
            },
            fontStyle_bold: {
                bold: true,
                fontSize: 14,
            },
            fontUnderLine: {
                fontSize: 14,
                bold: true,
                decoration: "underline",
                decorationStyle: "dotted",
                decorationColor: "black",
            },
            center: {
                alignment: "center",
                fontSize: 14,
            },
            tableExample: {
                alignment: "right",
                margin: [0, 5, 0, 15],
            },
            tableHeader: {
                bold: true,
                fontSize: 14,
                color: "black",
            },
            signature: {
                fontSize: 14,
                decoration: "underline",
                decorationStyle: "dotted",
                decorationColor: "black",
            },
        },
        pageOrientation: "portrait",
        // pageOrientation: "landscape",
        pageSize: "A4",
        pageMargins: [30, 20, 30, 30],
        defaultStyle: {
            font: "THSarabunNew",
            alignment: "justify",
        },
    };

    // var content = {
    //     pageOrientation: "landscape",
    //     pageSize: "A4",
    //     content: [header(), data2],
    //     pageMargins: [15, 20, 40, 40],
    //     defaultStyle: {
    //         font: "THSarabunNew",
    //         alignment: "justify",
    //     },
    // };

    generatePdf(true, dd, (dataUrl) => {
        setDialogPDF({ open: false, pdfURL: dataUrl });
        setLoading(false);
    });
};
